<mat-toolbar>
  <div class="logo-container">
    <img
      class="logo"
      [src]="logoUrl"
      [attr.alt]="tenantName + ' - Go to dashboard'"
      [routerLink]="['/portal/dashboard']"
    />
    <!-- <h5>{{tenantName}}</h5>  Place holder for future if needed-->
  </div>
  <div fxFlex fxLayout fxLayoutAlign="end">
    <button
      mat-button
      [matMenuTriggerFor]="menu"
      [attr.aria-label]="'Account menu for ' + userName"
    >
      {{ userName }}
      <mat-icon iconPositionEnd>expand_more</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="changePassword()">
        <mat-icon>vpn_key</mat-icon>
        <span>Change Password</span>
      </button>

      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Log out</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
